import {z} from 'zod';

// https://github.com/colinhacks/zod/issues/831
/**
 * Zod Helper for creating a tuple of literals. This is otherwise very verbose
 * because each array entry need to wrapped in `z.literal` call
 */
function createZodLiterals<Literals extends ReadonlyArray<z.Primitive>>(
	...literals: Literals
): {[Index in keyof Literals]: z.ZodLiteral<Literals[Index]>};

function createZodLiterals<Literals extends ReadonlyArray<z.Primitive>>(
	...literals: Literals
) {
	return literals.map((e) => z.literal(e));
}

export {createZodLiterals};

export default createZodLiterals;
